import SemiTransparentBackground from './SemiTransparentBackground';
export default SemiTransparentBackground;
